import { render, staticRenderFns } from "./canvasImgComponent.vue?vue&type=template&id=28a70940&scoped=true&"
import script from "./canvasImgComponent.vue?vue&type=script&lang=js&"
export * from "./canvasImgComponent.vue?vue&type=script&lang=js&"
import style0 from "./canvasImgComponent.vue?vue&type=style&index=0&id=28a70940&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a70940",
  null
  
)

export default component.exports